import { IFetchCustomerScheduleHistoryDTO } from 'modules/customer/domain/dtos';
import { ISchedulesRepository } from 'shared/domain/repositories';

export class FetchCustomerScheduleHistoryUseCase {
  constructor(private schedulesRepository: ISchedulesRepository) {}

  public async execute({ customerId, page }: IFetchCustomerScheduleHistoryDTO) {
    return this.schedulesRepository.findAll({
      customerId,
      page,
      filter: 'PAST',
    });
  }
}
